var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Category.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Category = ({
  color = '#353B60',
  opacity = '0.5',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.05",
    width: "24",
    height: "24",
    rx: "4",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    opacity: opacity,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5ZM6 13C5.44772 13 5 13.4477 5 14V18C5 18.5523 5.44772 19 6 19H10C10.5523 19 11 18.5523 11 18V14C11 13.4477 10.5523 13 10 13H6ZM13.7217 11.0001H18.2779C19.0457 11.0001 19.526 10.1706 19.1451 9.50392L16.8683 5.51949C16.4844 4.84767 15.5157 4.84767 15.1318 5.51949L12.855 9.50392C12.474 10.1706 12.9539 11.0001 13.7217 11.0001ZM12.7782 15.2929C12.3876 15.6834 12.3876 16.3166 12.7782 16.7071L15.3284 19.2574C15.7189 19.6479 16.3521 19.6479 16.7426 19.2574L19.2929 16.7071C19.6834 16.3166 19.6834 15.6834 19.2929 15.2929L16.7426 12.7426C16.3521 12.3521 15.7189 12.3521 15.3284 12.7426L12.7782 15.2929Z",
    fill: color
  })]
});